<template>
  <div class="md-layout" id="historic-departures">
    <div class="md-layout-item md-size-100">
      <h6 class="text-center" v-if="!loaded">
        <a href="#" @click.prevent="loadHistoricDepartures"
          >Load Historic Departures</a
        >
      </h6>

      <div v-if="loaded">
        <div v-if="Object.keys(departuresByYear).length > 0">
          <h5>Historic Departures ...</h5>
          <tour-tabs-departures-historic-panel
            :departuresByYear="departuresByYear"
          ></tour-tabs-departures-historic-panel>
        </div>
        <div v-else>
          <p class="alert alert-danger text-center">
            There are no historic departures for this Tour.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tourApi from "@/services/api/tour";
import TourTabsDeparturesHistoricPanel from "./TourTabsDeparturesHistoricPanel.vue";

export default {
  name: "TourTabsDeparturesHistoric",
  props: ["tour"],

  data() {
    return {
      departuresByYear: null,
      loaded: false
    };
  },
  components: { TourTabsDeparturesHistoricPanel },
  methods: {
    loadHistoricDepartures() {
      tourApi.getHistoricDepartures(this.tour.id).then(response => {
        this.loaded = true;
        this.departuresByYear = response.data.departures;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#historic-departures {
  margin-top: 30px;
  border-top: 1px solid $grey-500;
  padding-top: 20px;

  h5 {
    margin: 0;
  }

  h6 {
    margin-top: 0;
  }
}
</style>
